import { AngleKey, FormatKey } from '../insight/insightTypes';

export enum DistributionActionTypes {
  API_RESPONSE_SUCCESS = '@@distribution/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR   = '@@distribution/API_RESPONSE_ERROR',
  GENERATE             = '@@distribution/GENERATE',
  SET_ACTIVE_FORMAT    = '@@distribution/SET_ACTIVE_FORMAT',
  SET_COPIED           = '@@distribution/SET_COPIED',
  SET_FEEDBACK         = '@@distribution/SET_FEEDBACK',
  SET_PACK_ID          = '@@distribution/SET_PACK_ID',
  RESET                = '@@distribution/RESET',
}

export interface DistributionState {
  packId: string | null;
  angle: AngleKey | null;
  outputs: Partial<Record<FormatKey, string>>;
  activeFormat: FormatKey;
  copiedFormat: FormatKey | null;
  feedback: Partial<Record<FormatKey, 'up' | 'down'>>;
  isLoading: boolean;
  error: string | null;
}

export interface GeneratePayload {
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
  angle: AngleKey;
  userPov?: string;
  voiceFingerprint?: string;
}
